import { ACTIONS_TYPES } from "../utils/constants";

// meter activation
export function meterActivationRequest(payload) {
  console.log("recived meterActivationRequest, payload: ",payload);

  return {
    type: ACTIONS_TYPES.METER_ACTIVATION_REQUEST,
    payload
  }
}

export function meterActivationSuccess(response) {
  console.log("recieved action success: ", response);
  
  return {
    type: ACTIONS_TYPES.METER_ACTIVATION_SUCCESS,
    payload: response,
  }
}

export function meterActivationFailed(response) {
  console.log("recived meterActivationFailed, response: ",response);

  return {
    type: ACTIONS_TYPES.METER_ACTIVATION_FAILED,
    payload: response,
  }
}


// awaiting contractor
export function assignContractorRequest(payload) {
  
  return {
    type: ACTIONS_TYPES.ASSIGN_CONTRACTOR_REQUEST,
    payload
  }
}

export function assignContractorSuccess(response) {
  return {
    type: ACTIONS_TYPES.ASSIGN_CONTRACTOR_SUCCESS,
    payload: response,
  }
}

export function assignContractorFailed(response) {
  return {
    type: ACTIONS_TYPES.ASSIGN_CONTRACTOR_FAILED,
    payload: response,
  }
}

// awaiting inspector company
export function assignInspectorCompanyRequest(payload) {
  
  return {
    type: ACTIONS_TYPES.ASSIGN_INSPECTOR_COMPANY_REQUEST,
    payload
  }
}

export function assignInspectorCompanySuccess(response) {
  return {
    type: ACTIONS_TYPES.ASSIGN_INSPECTOR_COMPANY_SUCCESS,
    payload: response,
  }
}

export function assignInspectorCompanyFailed(response) {
  return {
    type: ACTIONS_TYPES.ASSIGN_INSPECTOR_COMPANY_FAILED,
    payload: response,
  }
}

// awaiting technician
export function assignTechnicianRequest(payload) {
  
  return {
    type: ACTIONS_TYPES.ASSIGN_TECHNICIAN_REQUEST,
    payload
  }
}

export function assignTechnicianSuccess(response) {
  return {
    type: ACTIONS_TYPES.ASSIGN_TECHNICIAN_SUCCESS,
    payload: response,
  }
}

export function assignTechnicianFailed(response) {
  return {
    type: ACTIONS_TYPES.ASSIGN_TECHNICIAN_FAILED,
    payload: response,
  }
}

//workspace - management-decision
export function managementDecisionRequest(payload) {
  return {
    type: ACTIONS_TYPES.MANAGEMENT_DECISION_REQUEST,
    payload
  }
}

export function managementDecisionSuccess(response) {
  return {
    type: ACTIONS_TYPES.MANAGEMENT_DECISION_SUCCESS,
    payload: response,
  }
}

export function managementDecisionFailed(response) {
  return {
    type: ACTIONS_TYPES.MANAGEMENT_DECISION_FAILED,
    payload: response,
  }
}

// awaitingInspector
export function awaitingInspectorRequest(payload) {
  return {
    type: ACTIONS_TYPES.AWAITING_INSPECTOR_REQUEST,
    payload
  }
}

export function awaitingInspectorSuccess(response) {
  return {
    type: ACTIONS_TYPES.AWAITING_INSPECTOR_SUCCESS,
    payload: response,
  }
}

export function awaitingInspectorFailed(response) {
  return {
    type: ACTIONS_TYPES.AWAITING_INSPECTOR_FAILED,
    payload: response,
  }
}

   //workspace - QUALITY CONTROL
   export function qualityControlRequest(payload) {
    return {
      type: ACTIONS_TYPES.QUALITY_CONTROL_REQUEST,
      payload
    }
  }
  
  export function qualityControlSuccess(response) {
    return {
      type: ACTIONS_TYPES.QUALITY_CONTROL_SUCCESS,
      payload: response,
    }
  }
  
  export function qualityControlFailed(response) {
    return {
      type: ACTIONS_TYPES.QUALITY_CONTROL_FAILED,
      payload: response,
    }
  }

  //workspace - failedExecution
  export function failedExecutionRequest(payload) {
    return {
      type: ACTIONS_TYPES.FAILED_EXECUTION_REQUEST,
      payload
    }
  }
  
  export function failedExecutionSuccess(response) {
    return {
      type: ACTIONS_TYPES.FAILED_EXECUTION_SUCCESS,
      payload: response,
    }
  }
  
  export function failedExecutionFailed(response) {
    return {
      type: ACTIONS_TYPES.FAILED_EXECUTION_FAILED,
      payload: response,
    }
  }

  export function myWorkspaceReset() {
    return {
      type: ACTIONS_TYPES.MY_WORKSPACE_RESET,
    }
  }
